import moment from "moment-timezone";

export const TIMEZONE_OPTIONS = [
  { value: "America/New_York", label: "America/New York" },
  { value: "America/Los_Angeles", label: "America/Los Angeles" },
  { value: "America/Chicago", label: "America/Chicago" },
  { value: "America/Denver", label: "America/Denver" },
  { value: "America/Toronto", label: "America/Toronto" },
  { value: "America/Vancouver", label: "America/Vancouver" },
  { value: "America/Mexico_City", label: "America/Mexico City" },
  { value: "America/Sao_Paulo", label: "America/São Paulo" },
  { value: "Europe/London", label: "Europe/London" },
  { value: "Europe/Paris", label: "Europe/Paris" },
  { value: "Europe/Berlin", label: "Europe/Berlin" },
  { value: "Europe/Amsterdam", label: "Europe/Amsterdam" },
  { value: "Europe/Madrid", label: "Europe/Madrid" },
  { value: "Europe/Rome", label: "Europe/Rome" },
  { value: "Europe/Istanbul", label: "Europe/Istanbul" },
  { value: "Asia/Dubai", label: "Asia/Dubai" },
  { value: "Asia/Kolkata", label: "Asia/Kolkata" },
  { value: "Asia/Shanghai", label: "Asia/Shanghai" },
  { value: "Asia/Tokyo", label: "Asia/Tokyo" },
  { value: "Asia/Singapore", label: "Asia/Singapore" },
  { value: "Australia/Sydney", label: "Australia/Sydney" },
  { value: "Australia/Melbourne", label: "Australia/Melbourne" },
  { value: "Pacific/Auckland", label: "Pacific/Auckland" },
  { value: "UTC", label: "UTC" },
];

/**
 * "GMT-6 • 1:07 p.m" — a zone's UTC offset and its current wall-clock time.
 * @param {string} zone IANA zone
 * @param {number} nowMs
 */
export function formatZoneOffsetAndTime(zone, nowMs) {
  const m = moment(nowMs).tz(zone);
  const offsetMin = m.utcOffset();
  const sign = offsetMin < 0 ? "-" : "+";
  const absMin = Math.abs(offsetMin);
  const offHours = Math.floor(absMin / 60);
  const offMins = absMin % 60;
  const offset = `GMT${sign}${offHours}${
    offMins ? `:${String(offMins).padStart(2, "0")}` : ""
  }`;
  const hour24 = m.hour();
  const minute = String(m.minute()).padStart(2, "0");
  const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
  const meridiem = hour24 < 12 ? "a.m" : "p.m";
  return `${offset} • ${hour12}:${minute} ${meridiem}`;
}

/**
 * The shared option list plus, when the gym's configured zone is not one of
 * them, that zone prepended —-so the public page can always default to it.
 * @param {string} [gymZone]
 */
export function timezoneOptionsWith(gymZone) {
  if (!gymZone || TIMEZONE_OPTIONS.some((o) => o.value === gymZone)) {
    return TIMEZONE_OPTIONS;
  }
  return [
    { value: gymZone, label: gymZone.replace(/_/g, " ") },
    ...TIMEZONE_OPTIONS,
  ];
}

/** `America/New York - GMT-4 • 6:52 a.m` — the full option label used by both pages. */
export function timezoneOptionLabel(option, nowMs) {
  return `${option.label} - ${formatZoneOffsetAndTime(option.value, nowMs)}`;
}
